import { Rules, methods } from 'sigma-mappings';
import NotImplemented from '@/components/NotImplemented';
import BaseGasRatioContent from './baseGasRatio/Content';
import DuvalTriangle1Print from './duval/Triangle1';
import DuvalTriangle4Print from './duval/Triangle4';
import DuvalTriangle5Print from './duval/Triangle5';

/**
 * Definição de components de conteúdo para os cards de impressão.
 *
 * Cada método tem a sua definição de components.
 *
 * Interface:
 * {
 *   content: OBRIGATÓRIO, é o conteúdo principal do card.
 * }
 *
 * Todos os components receberão a prop "data", sem tipo específico, com os dados retornados do
 * back-end. Cada card tratará "data" de maneira individual conforme sua regra.
 */
export default {
  [Rules.IEC_60599]: {
    direction: 'column',
    [methods[Rules.IEC_60599].GASES_RATIO_2015]: {
      content: BaseGasRatioContent,
    },
  },
  [Rules.IEEE_C57_104]: {
    direction: 'column',
    [methods[Rules.IEEE_C57_104].DOERNENBURG]: {
      content: BaseGasRatioContent,
    },
    [methods[Rules.IEEE_C57_104].ROGERS]: {
      content: BaseGasRatioContent,
    },
    [methods[Rules.IEEE_C57_104].CLASSIFICATION_IN_CONDITIONS]: {
      content: NotImplemented,
    },
  },
  [Rules.NBR_7274]: {
    direction: 'column',
    [methods[Rules.NBR_7274].GASES_RATIO_2012]: {
      content: BaseGasRatioContent,
    },
  },
  [Rules.DUVAL]: {
    direction: 'row',
    [methods[Rules.DUVAL].TRIANGLE_1]: {
      content: DuvalTriangle1Print,
    },
    [methods[Rules.DUVAL].TRIANGLE_4]: {
      content: DuvalTriangle4Print,
    },
    [methods[Rules.DUVAL].TRIANGLE_5]: {
      content: DuvalTriangle5Print,
    },
  },
};
